<main-form-modal (toggleChange)="setVal($event)">
    <ng-template #customHtmlElements>
        <div [ngSwitch]="editMode">
            <vouchersOrganization-edit *ngSwitchCase="true"></vouchersOrganization-edit>
            <vouchersOrganization-details *ngSwitchCase="false"></vouchersOrganization-details>
        </div>
    </ng-template>
</main-form-modal>